import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  title: { marginTop: theme.spacing(3), marginBottom: theme.spacing(3) }
}));

export default function PageTitle({ title }: { title: string }): JSX.Element {
  const classes = useStyles();
  return (
    <div className={classes.title}>
      <Typography variant={"h4"}>{title}</Typography>
    </div>
  );
}
